import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/TestView123.vue'
import TypeDetailPage from '@/views/TypeDetailPage.vue'
import AddressManageView from '../views/AddressManage.vue'
import AddNewAddress from '../views/AddNewAddress.vue'
import GaodeLocationView from '../views/GaodeLocation.vue'
import LoginView from '../views/LoginView.vue'
import EditAddressView from '@/views/EditAddress.vue'
import IndexView from "../views/IndexView.vue"
import OrderInfoView from '@/views/OrderInfoView.vue'
import TestView from '../views/TestView.vue'
import RecycleView from '../views/RecycleView.vue'
import MessageView from '@/views/MessageView.vue'
import ShoppingView from '@/views/ShoppingView.vue'
import CompanyListView from '@/views/CompanyListView.vue'
import CompanyDetail from '@/views/CompanyDetail.vue'
import CompanyItemView from '@/views/CompanyItemView.vue'
import CashierView from '@/views/CashierView.vue'
import PaySuccessView from '@/views/PaySuccessView.vue'
import UserAgreement from '@/views/UserAgreement.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import DynamicSquareView from '@/views/DynamicSquareView.vue'
import PublishDynamicView from '@/views/PublishDynamicView.vue'
import DynamicDetailView from '@/views/DynamicDetailView.vue'
import MyDynamicsView from '@/views/MyDynamicsView.vue'
import FriendsSquareView from '@/views/FriendsSquareView.vue'
import UserProfileView from '@/views/UserProfileView.vue'
import ReportView from '@/views/ReportView.vue'


Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/',
    redirect: 'index'
  },
  {
    path: "/login",
    name: "login",
    component: LoginView
  },
  {
    path: "/message/:chatRoomId",
    name: "message",
    component: MessageView
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: UserAgreement
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: PrivacyPolicy
  },
  {
    path: "/recycle",
    name: "recycle",
    component: RecycleView
  },
  {
    path: "/test",
    name: "test",
    component: TestView
  },
  {
    path: "/OrderInfoView/:id",
    name: "OrderInfo",
    component: OrderInfoView
  },
  {
    path: "/cashier/:id",
    name: "Cashier",
    component: CashierView
  },
  {
    path: "/paySuccess/:id",
    name: "PaySuccess",
    component: PaySuccessView
  },
  {
    path: '/index',
    name: 'index',
    component: IndexView,
    children: [
      {
        path: '/',
        name: 'home',
        component: HomeView
      },
      {
        path: '/mineInfo',
        name: 'mineInfo',
        component: () => import('../views/MineInfoView.vue')
      },
      {
        path: "/MessageList",
        name: "MessageList",
        component: () => import('../views/MessageListView.vue')
      },
      {
        path: "/dynamicSquare",
        name: "DynamicSquare",
        component: DynamicSquareView
      },
      {
        path: "/publishDynamic",
        name: "PublishDynamic",
        component: PublishDynamicView
      },
      {
        path: "/orderListView/:tab",
        name: "OrderListView",
        component: () => import('../views/orderListView.vue')
      },

      {
        path: "/ShoppingView",
        name: "ShoppingView",
        component: ShoppingView
      },
      {
        path: "/TypeDetailPage/:type",
        name: "TypeDetailPage",
        component: TypeDetailPage
      },
    ]
  },
  {
    path: "/dynamic/:id",
    name: "DynamicDetail",
    component: DynamicDetailView
  },
  {
    path: "/myDynamics",
    name: "MyDynamics",
    component: MyDynamicsView
  },
  {
    path: "/friendsSquare",
    name: "FriendsSquare",
    component: FriendsSquareView
  },
  {
    path: "/userProfile/:userId",
    name: "UserProfile",
    component: UserProfileView
  },
  {
    path: "/report/:targetType/:targetId",
    name: "Report",
    component: ReportView
  },
  {
    path: "/CompanyListView/:type",
    name: "CompanyListView",
    component: CompanyListView
  },
  {
    path: "/CompanyListForSearch/:search",
    name: "CompanyListForSearch",
    component: () => import('../views/CompanyListForSearch.vue')
  },
  {
    path: '/address',
    name: 'address',
    component: AddressManageView
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: AddNewAddress,
  },
  {
    path: '/editAddress/:id',
    name: 'editAddress',
    component: EditAddressView,

  },
  {
    path: "/gaodeLocation",
    name: "gaodeLocation",
    component: GaodeLocationView
  },
  {
    path:"/writeComment/:orderId/:companyId",
    name:"writeComment",
    component:() => import('../views/WriteCommentView.vue')
  },
  {
    path: '/CompanyDetail/:serverId',
    name: 'CompanyDetail',
    component: CompanyDetail
  },
  {
    path: '/companyItem/:itemId',
    name: 'companyItem',
    component: CompanyItemView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
